import type { AnyFSA } from '@makemydeal/dr-browser-utils';
import { type DashMiddleware, type DashNext, type DashStore } from '@makemydeal/dr-shared-store';
import { EMPLOYEE_DETAILS_START_UPDATE_REQUEST } from '../actionTypes/employeeDetailsActionTypes';
import { sendEmployeeUpdate } from '../actions/employeeDetailsActionCreators';

export const middleware: DashMiddleware = (store: DashStore) => (next: DashNext) => (action: AnyFSA) => {
    next(action);

    switch (action.type) {
        case EMPLOYEE_DETAILS_START_UPDATE_REQUEST: {
            store.dispatch(sendEmployeeUpdate(action.payload.employees));
            break;
        }
    }
};
